module.exports = __webpack_public_path__ + "static/img/3.cd94429.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/3.png
// module id = A5jR
// module chunks = 0